var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_7_16596",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_7_16596",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAA3ElEQVR42mNgGAWDG3gylBMNSxiUSDVek+Efw38S4FlSLXAhyfj/DK/Is2ATQygR8C35FnQTpfbJqAVUsiCe4THDOzj8DLbgO5IIKtzJwEOqBZdJTJi+pFpwk+E/wz+Gu1B4j+ELww+GR3A+MnwLtiCEHAu+EhXmNaMWjFowasGoBaMWjFoAt6CMwRgKX1LbgjnkteyIt2ADFguuUNOCBrCRuxlmwuFkBgNaRjKRYNQCoiz4jRRxuOEp8iy4QWLTMYhUC6aQZPx7BllSLWBk0IRnfsKQf7QbPgrAAACZsbgsO7crTAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.00a1a9e8f82b11d5e09037f939daf69b.svg";
export { ForwardRef as ReactComponent };